// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ajax from '@/utils/ajax.js'
//element-ui use
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
require('swiper/dist/css/swiper.css')
Vue.use(VueAwesomeSwiper)
import 'babel-polyfill'
import 'jquery'

import '@/assets/css/amazeui.css'

Vue.component('AdModule',()=> import ('@/components/AdModule.vue'))
Vue.component('TopModule',()=> import ('@/components/TopModule.vue'))
Vue.component('LoginModule',()=> import ('@/components/LoginModule.vue'))
Vue.component('ColumnList',()=> import ('@/components/ColumnList.vue'))
Vue.component('ColumnArt',()=> import ('@/components/ColumnArt.vue'))
Vue.component('ColumnArt2',()=> import ('@/components/ColumnArt2.vue'))
Vue.component('BadgeBase',()=> import ('@/components/BadgeBase.vue'))
Vue.component('SwiperH',()=> import ('@/components/SwiperH.vue'))
Vue.component('Footer',()=> import ('@/components/Footer.vue'))
Vue.component('ArtDetail',()=> import ('@/components/ArtDetail.vue'))
import {webInfo} from '@/api/base'

Vue.config.productionTip = false
Vue.prototype.$ajax = ajax;
/* eslint-disable no-new */



import {getPortalToken} from '@/api/base'

getPortalToken().then(_=>{
  
  const data = webInfo()
Vue.prototype.webInfo = data

document.title = data.school_name


  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js